// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8b551ff705b0b8694e75","655":"d035c61cb15671988230"}[chunkId] + ".js";
};